/*globals Ob1Validation, Tms, newEvent*/
(function () {
    "use strict";
    const formUrl = document.eligibiliteAdresse.action;
    const elgUrl = formUrl.substring(0, formUrl.lastIndexOf("/"));
    if (!window.location.href.startsWith(elgUrl)) {
        history.replaceState(null, "", elgUrl + window.location.search + window.location.hash);
    }
}());

document.addEventListener("DOMContentLoaded", function () {
    "use strict";

    const domCache = {
        alertNd: document.getElementById("alert-nd"),
        alertAddress: document.getElementById("alert-address"),
        alertAddressBottom: document.getElementById("alert-address-bottom"),
        alertBoth: document.getElementById("alert-both"),
        alertBothBottom: document.getElementById("alert-both-bottom"),
        phonenumberInput: document.getElementById("phonenumber"),
        invalidFeedbackPhonenumber: document.getElementById("invalid-feedback_phonenumber"),
        searchfieldResults: document.getElementById("search-field-results"),
        addressNotFoundListItem: document.getElementById("search-field-results-shadow").firstElementChild,
        addressErrorInput: document.eligibiliteNd.errAddr,
        searchfield: document.getElementById("search-field-1"),
        addressSubmitBtn: document.getElementById("addressSubmitBtn"),
        carteElimapNavItem: document.getElementById("carte-elimap-nav-item")
    };

    const tmsEvents = (function () {

        const makeEvent = function (spec) {
            return () => Tms.link({
                category: spec.jsEventCategory,
                action: spec.jsEventAction,
                label: spec.jsEventLabel
            });
        };

        return {
            phoneNumberNotMobileTmsEvent: makeEvent(function (dataset) {
                return {
                    jsEventCategory: dataset.jsEventCategory,
                    jsEventAction: dataset.jsEventActionMsisdn,
                    jsEventLabel: dataset.jsEventLabel
                };
            }(domCache.invalidFeedbackPhonenumber.dataset)),
            phoneNumberBadFormatTmsEvent: makeEvent(domCache.invalidFeedbackPhonenumber.dataset),
            ndErrorTmsEvent: makeEvent(domCache.alertNd.dataset),
            addressErrorTmsEvent: makeEvent(domCache.alertAddress.dataset),
            bothErrorsTmsEvent: makeEvent(domCache.alertBoth.dataset)
        };
    }());

    const state = {
        currentAnchor: document.getElementsByTagName("main")[0].dataset.defaultHash,
        hasNdError: !domCache.alertNd.hidden || !domCache.alertBoth.hidden,
        hasAddressNotFoundError: domCache.addressErrorInput.value === "true"
    };

    const anchorMap = Array.from(document.querySelectorAll("li.nav-item a:not(.down)"))
        .reduce(function (map, navLink) {
            const anchor = navLink.getAttribute("href");
            navLink.addEventListener("click", () => window.location = anchor);
            map.set(anchor, {
                navLink: navLink,
                panel: document.getElementById(navLink.getAttribute("aria-controls"))
            });
            return map;
        }, new Map());

    const updateView = function () {
        anchorMap.forEach(function (value, anchor) {
            const isSelected = anchor === state.currentAnchor;
            value.navLink.setAttribute("aria-expanded", isSelected.toString());
            const navItem = value.navLink.closest("li");
            navItem.classList.toggle("active", isSelected);
            if (isSelected) {
                const expandLink = navItem.querySelector("a.down");
                if (expandLink != null) {
                    expandLink.textContent = value.navLink.textContent;
                }
            }
            ["active", "show"].forEach((cssClass) => {
                value.panel.classList.toggle(cssClass, isSelected);
            });
        });
        const bothErrors = state.hasNdError && state.hasAddressNotFoundError;
        domCache.alertBoth.hidden = !bothErrors;
        domCache.alertBothBottom.hidden = !bothErrors;
        domCache.alertNd.hidden = bothErrors || !state.hasNdError;
        domCache.alertAddress.hidden = bothErrors || !state.hasAddressNotFoundError;
        domCache.alertAddressBottom.hidden = bothErrors || !state.hasAddressNotFoundError;
        domCache.addressErrorInput.value = state.hasAddressNotFoundError;
    };

    const onHashChange = function () {
        const loc = window.location;
        const hash = loc.hash;
        const currentAnchor = state.currentAnchor;
        if (hash !== currentAnchor && anchorMap.has(hash)) {
            state.currentAnchor = hash;
            updateView();
        } else if (hash !== currentAnchor) {
            const newUrl = loc.origin + loc.pathname + loc.search + currentAnchor;
            window.history.replaceState({hash: currentAnchor}, "panel", newUrl);
        }
    };

    const onPhoneNumberChange = function () {
        if (state.hasNdError) {
            state.hasNdError = false;
            domCache.phonenumberInput.removeEventListener("input", onPhoneNumberChange);
            domCache.phonenumberInput.removeEventListener("change", onPhoneNumberChange);
            updateView();
        }
    };

    const onPhoneNumberInvalid = function () {
        const value = domCache.phonenumberInput.value;
        if (value.startsWith("06") || value.startsWith("07")) {
            tmsEvents.phoneNumberNotMobileTmsEvent();
        } else {
            tmsEvents.phoneNumberBadFormatTmsEvent();
        }
    };

    const onClickAddressNotFound = function () {
        if (!state.hasAddressNotFoundError) {
            state.hasAddressNotFoundError = true;
            if (state.hasNdError) {
                tmsEvents.bothErrorsTmsEvent();
            } else {
                tmsEvents.addressErrorTmsEvent();
            }
            updateView();
        }
    };

    const onSearchfieldResultsUpdate = function () {
        const addressNotFoundListItem = domCache.addressNotFoundListItem.cloneNode(true);
        domCache.searchfieldResults.appendChild(addressNotFoundListItem);
        const resultLines = Array.from(domCache.searchfieldResults.getElementsByTagName("li"));
        resultLines.forEach(function (resultLine) {
            resultLine.setAttribute("aria-setsize", resultLines.length.toString());
        });
        addressNotFoundListItem.setAttribute("aria-posinset", resultLines.length.toString());
        addressNotFoundListItem.addEventListener("click", onClickAddressNotFound);
        if (state.hasAddressNotFoundError) {
            state.hasAddressNotFoundError = false;
            updateView();
        }
    };

    const onSearchfieldResultSelected = function () {
        if (state.hasAddressNotFoundError) {
            state.hasAddressNotFoundError = false;
            updateView();
        }
        if (domCache.searchfield.validationMessage === "wait") {
            domCache.searchfield.setCustomValidity("");
            domCache.addressSubmitBtn.dispatchEvent(newEvent("click"));
        }
    };

    const onClickSubmitAddress = function () {
        if (document.getElementById("address-city-code").value === ""
            && domCache.searchfieldResults.querySelectorAll("li").length > 1) {
            domCache.searchfield.setCustomValidity("wait");
            domCache.searchfieldResults.firstElementChild.dispatchEvent(newEvent("click"));
        }
    };

    const addTrackingForFaqLink = function () {
        function toBroadbandTmsFormat(string) {
            return string.normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/’/g, "_")
                .split(" ")
                .join("_")
                .toLowerCase();
        }

        document.querySelectorAll(".accordion-card-body").forEach(
            function (edito) {

                edito.querySelectorAll("a").forEach(
                    function (link) {
                        link.dataset.oeventCategory = "zone_faq";
                        link.dataset.oeventLabel = link.href;
                        link.dataset.oeventAction = toBroadbandTmsFormat(link.innerText);
                    }
                );
            }
        );
    };

    const scrollToFormTitle = function () {
        document.getElementById("form-title").scrollIntoView({behavior: "smooth"});
    };

    (function init() {
        Ob1Validation.validateForm(document.eligibiliteAdresse);
        Ob1Validation.on(domCache.searchfield)
            .addConstraint("noResult", function (sf) {
                return sf.value === "" || document.getElementById("address-city-code").value !== "";
            });
        Ob1Validation.validateForm(document.eligibiliteNd);
        if (state.hasNdError) {
            if (state.hasAddressNotFoundError) {
                window.addEventListener("load", tmsEvents.bothErrorsTmsEvent);
            } else {
                window.addEventListener("load", tmsEvents.ndErrorTmsEvent);
            }
            domCache.phonenumberInput.addEventListener("input", onPhoneNumberChange);
            domCache.phonenumberInput.addEventListener("change", onPhoneNumberChange);
        }
        domCache.phonenumberInput.addEventListener("invalid", onPhoneNumberInvalid);
        domCache.searchfield.addEventListener("ob1-searchfield-results-update", onSearchfieldResultsUpdate);
        domCache.searchfield.addEventListener("ob1-searchfield-result-validated", onSearchfieldResultSelected);
        domCache.addressSubmitBtn.addEventListener("click", onClickSubmitAddress);
        window.addEventListener("hashchange", onHashChange);
        addTrackingForFaqLink();
        document.getElementById("addressSubmitBtn").disabled = false;
        if (domCache.carteElimapNavItem !== undefined && domCache.carteElimapNavItem !== null) {
            domCache.carteElimapNavItem.addEventListener("click", scrollToFormTitle);
        }
        onHashChange();
    }());
});
